module.exports = __webpack_public_path__ + "img/feiwu.345281eb.svg";